module.exports = __webpack_public_path__ + "img/about-list1-1.ac980089.png";